import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const METRICS = [
  { value: "30+ Years", label: "Enterprise Tech Leadership" },
  { value: "$100M+ ARR", label: "Scale Capabilities" },
  { value: "Global 2000", label: "Architectural Validation" },
];

export default function MetricsMarquee() {
  const [outcomes, setOutcomes] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/outcomes`)
      .then((res) => setOutcomes(res.data))
      .catch(() => {});
  }, []);
  return (
    <section
      id="metrics"
      data-testid="metrics-marquee-section"
      className="border-y border-white/10 py-10 lg:py-14 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 mb-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
          Background
        </p>
      </div>
      <Marquee speed={35} gradient={false} pauseOnHover>
        {[...Array(3)].map((_, copy) =>
          METRICS.map((metric) => (
            <div
              key={`${copy}-${metric.value}`}
              data-testid={copy === 0 ? `metric-${metric.label.toLowerCase().replace(/\s+/g, "-")}` : undefined}
              aria-label={`${metric.value} — ${metric.label}`}
              className="flex items-center gap-8 lg:gap-12 mx-8 lg:mx-12"
              aria-hidden={copy > 0}
            >
              <span className="font-serif italic text-3xl sm:text-4xl lg:text-6xl text-white whitespace-nowrap">
                {metric.value}
              </span>
              <span className="font-mono text-xs lg:text-sm uppercase tracking-[0.25em] text-white/50 whitespace-nowrap">
                {metric.label}
              </span>
              <span className="text-[#E6E4D9]/60 text-lg select-none">◆</span>
            </div>
          ))
        )}
      </Marquee>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 mt-14 lg:mt-20">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/50 mb-10">
            06 — Selected Outcomes
          </p>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {outcomes.map((outcome, i) => (
            <Reveal key={outcome.slug} delay={i * 0.06}>
              <Link
                to={`/insights/${outcome.slug}`}
                data-testid={`outcome-card-${outcome.slug}`}
                aria-label={`${outcome.value} — ${outcome.label}`}
                className="group block h-full border border-white/10 bg-[#0A0A0A] p-8 lg:p-10 hover:bg-[#101010] transition-colors duration-500"
              >
                <span className="font-serif italic text-2xl lg:text-3xl text-white block mb-4 leading-snug">
                  {outcome.value}
                </span>
                <span className="block text-sm font-light leading-relaxed text-white/60 mb-6">
                  {outcome.label}
                </span>
                <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 group-hover:text-[#E6E4D9] transition-colors duration-300">
                  Blueprint
                  <ArrowUpRight size={11} weight="bold" />
                </span>
                {outcome.provenance && (
                  <span className="block mt-3 font-mono text-[9px] uppercase tracking-[0.2em] text-white/30">
                    {outcome.provenance}
                  </span>
                )}
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
